let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("952Nd")).then(() => parcelRequire('1u3hM'));